// Shared theme tokens for ProjectDetail. Aligned with DashboardHeader gradient.

export const HERO_GRADIENT =
  'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #1e40af 100%)';

export const HERO_DECORATION = {
  '&::before': {
    content: '""',
    position: 'absolute',
    top: -60,
    right: -40,
    width: 240,
    height: 240,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.05)',
    pointerEvents: 'none'
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -80,
    right: 100,
    width: 180,
    height: 180,
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.03)',
    pointerEvents: 'none'
  }
};

export const STATUS_STYLES = {
  planning: { bg: '#EEF2FF', color: '#4338CA', dot: '#6366F1' },
  planned: { bg: '#EEF2FF', color: '#4338CA', dot: '#6366F1' },
  in_progress: { bg: '#ECFDF5', color: '#047857', dot: '#10B981' },
  ongoing: { bg: '#ECFDF5', color: '#047857', dot: '#10B981' },
  on_hold: { bg: '#FFF7ED', color: '#C2410C', dot: '#F97316' },
  paused: { bg: '#FFF7ED', color: '#C2410C', dot: '#F97316' },
  cancelled: { bg: '#FEF2F2', color: '#B91C1C', dot: '#EF4444' },
  terminated: { bg: '#FEF2F2', color: '#B91C1C', dot: '#EF4444' },
  completed: { bg: '#F0FDF4', color: '#15803D', dot: '#22C55E' },
  finished: { bg: '#F0FDF4', color: '#15803D', dot: '#22C55E' },
  retention: { bg: '#FAF5FF', color: '#7E22CE', dot: '#A855F7' },
  closed: { bg: '#F1F5F9', color: '#475569', dot: '#94A3B8' },
  archived: { bg: '#F1F5F9', color: '#475569', dot: '#94A3B8' }
};

export const getStatusStyle = (status) =>
  STATUS_STYLES[status] || { bg: '#EEF2FF', color: '#4338CA', dot: '#6366F1' };
